import { useEffect } from 'react'

export const useServiceWorker = () => {
  useEffect(() => {
    //  detencción iOS
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
    
    if (isIOS) {
      console.log('iOS detectado - Service Worker limitado');
      
      // En iOS Safari normal, no intentar registro de SW para push
      const isStandalone = (window.navigator as any).standalone === true;
      const isPWA = window.matchMedia('(display-mode: standalone)').matches;
      
      if (!isStandalone && !isPWA) {
        console.log('iOS Safari: SW no recomendado para push notifications');
        return; //  SALIR TEMPRANO EN iOS SAFARI
      }
    }

    // Solo registrar SW si no es iOS Safari normal
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then(registration => {
          console.log('Service Worker registrado:', registration.scope);
        })
        .catch(error => {
          console.warn(' Error registrando Service Worker:', error);
        });
    }
  }, []);
};